import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LaborExtraState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: LaborExtraState = {
  data: [],
  isLoading: false,
  error: null,
};

const LaborExtraSlice = createSlice({
  name: 'laborExtras',
  initialState,
  reducers: {
    setLaborExtras: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setLaborExtrasLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setLaborExtrasError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setLaborExtras, setLaborExtrasLoading, setLaborExtrasError } = LaborExtraSlice.actions;

export default LaborExtraSlice.reducer;
